import Alpine from 'alpinejs';
window.Alpine = Alpine;

import list from "./modules/list";
Alpine.data('list', list);

import modal from "./modules/modal";
Alpine.data('modal', modal);

Alpine.start();
